import { createAsyncThunk } from "@reduxjs/toolkit";
import { OrdenadorUnidade } from "model/reino/Unidade";
import { Api } from "service/api/Api";
import { ApiMembrosUnidade } from "service/api/reino/ApiMembrosUnidade";
import { RootState } from "store/store";
import { EstadoRequisicao } from "store/types";
import { ErrosUtils } from "util/ErrosUtils";
import { UnidadesResponsaveisState } from "./UnidadesResponsaveis.types";



export class UnidadesResponsaveisAction {
  static readonly carregar = createAsyncThunk(
    'UnidadesResponsaveis/carregar',
    async (_, {getState, rejectWithValue, requestId}) => {
      const { unidadesResponsaveis: estado } = getState() as RootState
      
      if (isEvitarRequisicao(estado, requestId)) {
        return;
      }

      // FIXME: Pegar o reino do state

      try {
        const responsaveisTecnicos = await ApiMembrosUnidade.getAll(Api.REINO_PADRAO);
        const unidades = responsaveisTecnicos.map(it => it.unidade);

        return {
          responsaveisTecnicos: responsaveisTecnicos,
          unidadesResponsaveis: OrdenadorUnidade.removerRepetidosEOrdernar(unidades)
        }
      } catch (e) {
        return rejectWithValue(ErrosUtils.converterErroAxiosParaErroSistema(e));
      }
    }
  )
}


function isEvitarRequisicao(estado: UnidadesResponsaveisState, requestId: string): boolean {
  return estado.estado !== EstadoRequisicao.CARREGANDO
      || estado.currentRequestId !== requestId
}